import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

import { QueryState } from "@/components/query-state";
import { useGetAvailableDexes } from "@/generated/api/pools/pools";

export const Route = createFileRoute("/pools")({ component: PoolsLayout });

function PoolsLayout() {
    const dexes = useGetAvailableDexes();

    return (
        <div className="space-y-3 md:space-y-4">
            <QueryState
                query={dexes}
                isEmpty={(data) => data.available_dexes.length === 0}
                emptyMessage="The bot tracks no DEX."
            >
                {(data) => (
                    // One swipeable row on a phone instead of ragged wrapped lines.
                    <div
                        className="no-scrollbar -mx-3 flex snap-x gap-1.5 overflow-x-auto px-3 sm:-mx-4 sm:px-4 md:mx-0 md:flex-wrap md:px-0"
                        role="tablist"
                        aria-label="DEX"
                    >
                        {data.available_dexes.map((dex) => (
                            <Link
                                key={dex}
                                to="/pools/$dex"
                                params={{ dex }}
                                role="tab"
                                className="shrink-0 snap-start rounded-full border px-4 py-2 text-[0.9375rem] font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
                                activeProps={{
                                    className: "border-primary bg-primary text-primary-foreground hover:bg-primary",
                                    "aria-selected": true,
                                }}
                            >
                                {dex}
                            </Link>
                        ))}
                    </div>
                )}
            </QueryState>
            <Outlet />
        </div>
    );
}
